__webpack_require__.p = "/consumer-and-producer-surplus/";